import Vue from 'vue'
import model from '@/components/model'
import Rating from '@/components/Rating'
import ModalRating from '@/components/ModalRating'

Vue.component('app-model', model)
Vue.component('modal-rating', ModalRating)
Vue.component('app-rating', Rating)

export default {}



// WEBPACK FOOTER //
// ./src/components/index.js